import { MinusCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import breakpoints from '../../../utilities/breakpoints';
import { type VehicleImageProps } from '../../context';

type VehicleRemoveButtonProps = {
    remove: () => void;
};

const RemoveIcon = styled(MinusCircleOutlined)`
    font-size: 17px;
    &.anticon {
        color: #000000;
    }
`;
const StyledRemoveIconWrapper = styled.div`
    border-radius: 4px;
    background: #ffffff;
    padding: 10px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 16px;
    right: 20px;
`;
const VehicleRemoveButton = ({ remove }: VehicleRemoveButtonProps) => (
    <StyledRemoveIconWrapper>
        <RemoveIcon onClick={remove} />
    </StyledRemoveIconWrapper>
);

const ImageBox = styled.div`
    width: 100%;
    position: relative;
    padding: 0 4px;
`;

const Image = styled.img`
    width: 100%;
    max-height: var(--calculator-comparison-vehicle-image-height);
    @media (max-width: ${breakpoints.xxl}) {
        max-height: var(--calculator-comparison-vehicle-image-height-xl);
    }
    @media (max-width: ${breakpoints.xl}) {
        max-height: var(--calculator-comparison-vehicle-image-height-lg);
    }
    @media (max-width: ${breakpoints.lg}) {
        max-height: var(--calculator-comparison-vehicle-image-height-m);
    }
    @media (max-width: ${breakpoints.md}) {
        max-height: var(--calculator-comparison-vehicle-image-height-sm);
    }
    object-fit: cover;
    border-radius: var(--vehicle-image-border-radius);
    aspect-ratio: 16/9;
`;

const ImageContainer = styled.div`
    height: content-fit;
    max-height: var(--calculator-comparison-vehicle-image-height);
    @media (min-width: ${breakpoints.xxl}) {
        max-height: var(--calculator-comparison-vehicle-image-height-xxl);
    }
    @media (min-width: ${breakpoints.xl}) {
        max-height: var(--calculator-comparison-vehicle-image-height-xl);
    }
    @media (min-width: ${breakpoints.lg}) {
        max-height: var(--calculator-comparison-vehicle-image-height-l);
    }
    display: flex;
    margin-bottom: 1rem;
`;

const VehicleImage = ({ src, remove, isRemovable, fieldKey }: VehicleImageProps) => (
    <ImageContainer className="comparison-image-container">
        <ImageBox>
            {isRemovable && <VehicleRemoveButton remove={remove} />}
            <Image src={src} />
        </ImageBox>
    </ImageContainer>
);

export default VehicleImage;
